import { getMarketsUrlPath } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { useQuery } from "@tanstack/react-query";

export const MARKET_BY_URL = "MARKET_BY_URL";

export function useMarketByIdQuery(urlPath?: string) {
	return useQuery({
		queryKey: [MARKET_BY_URL, urlPath],
		queryFn: processResponse(() => getMarketsUrlPath(urlPath!)),
		retry: false,
		refetchInterval: false,
		refetchIntervalInBackground: false,
		enabled: !!urlPath,
	});
}
